var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebars-layout',{attrs:{"showRightBar":false},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('profile-navigation')]},proxy:true}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }